import script from "./versions.vue?vue&type=script&setup=true&lang=ts"
export * from "./versions.vue?vue&type=script&setup=true&lang=ts"

import "./versions.vue?vue&type=style&index=0&id=84e9664e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84e9664e"]])

export default __exports__